import { useContext } from "react";
import { EventContext } from "@gp/components";
import { useGetAdditionalOfferEvent } from "@utils/offer";

export default function useGetIsEventFeatured(): boolean {
	const additionalOfferEventId = useGetAdditionalOfferEvent()?.eventId;
	const event = useContext(EventContext);

	return additionalOfferEventId === event.id;
}
